module.exports = __webpack_public_path__ + "static/img/2.fe7bc7f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/8/sp/2.png
// module id = sF9e
// module chunks = 0